const data: any = {
  func: { mainTitle: "京东联盟", subTitle: "京东联盟是由京东商城推出的面向全网的广告交易平台" },
  style: {
    backImageUrl:
      "//img13.360buyimg.com/imagetools/s2880x520_jfs/t1/148559/22/8401/179151/5f5f03efE30659ab8/f51eeee05209ec1c.jpg!q80",
    backColor: "#dddddd",
    backIcon:
      "//img13.360buyimg.com/imagetools/s18x24_jfs/t1/136497/17/9683/1216/5f5f0b37E19d29eb2/cebeceacf2f9e0bc.png!q80",
    isShowIcon: "show",
  },
  data: {},
  _clstag_: "jdzeus_jdunion_zeus_banner",
};
export default data;
